// removed by extract-text-webpack-plugin
module.exports = {"card":"CategoryCard_card_3wmMS","title":"CategoryCard_title_2xv0j","icon":"CategoryCard_icon_2F9-z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryCard/CategoryCard.css
// module id = 92
// module chunks = 0